// extracted by mini-css-extract-plugin
export var productForm = "ProductForm-module--productForm--rJAfT";
export var price = "ProductForm-module--price--in7Wy";
export var selector = "ProductForm-module--selector--Dn-Lp";